<template>
    <div class="advanced-helper">
        <div
            class="advanced-helper__label"
            :tabindex="tabindex"
            @click.stop="modalOpen = true"
            @keypress.enter="modalOpen = true"
        >
            {{ label }}
        </div>

        <teleport to="body">
            <lsn-modal :is-open="modalOpen">
                <div class="advanced-helper__modal sl-prompt sl-prompt--info">
                    <div class="sl-prompt__contents">
                        <div class="sl-prompt__title">
                            <template v-if="parameter?.form_label">
                                {{ parameter.form_label }}
                                &ndash;
                            </template>
                            {{ label }}
                        </div>

                        <div class="sl-prompt__text">
                            <div
                                v-for="(block, i) in blocks"
                                :key="i"
                                class="advanced-helper__block"
                                :class="{
                                    'advanced-helper__block--text': block.type === 'TEXT',
                                    'advanced-helper__block--image': block.type === 'IMAGE',
                                }"
                            >
                                <div v-if="block.type === 'TEXT'">
                                    {{ block.contents }}
                                </div>

                                <img
                                    v-else-if="block.type === 'IMAGE'"
                                    :src="block.contents.src"
                                    :alt="block.contents.alt ?? ''"
                                >
                            </div>
                        </div>
                    </div>

                    <div class="sl-prompt__actions">
                        <button
                            ref="closeBtn"
                            class="sl-prompt__button sl-prompt__button--white"
                            @click="modalOpen = false"
                        >
                            {{ $t('common.close') }}
                        </button>
                    </div>
                </div>
            </lsn-modal>
        </teleport>
    </div>
</template>

<script setup>
import { nextTick, ref, useTemplateRef, watch } from 'vue';

defineProps({
    label:
    {
        type:     String,
        required: true,
    },

    blocks:
    {
        type:    Array,
        default: () => [],
    },

    parameter:
    {
        type:    [Object, null],
        default: null,
    },

    tabindex:
    {
        type:    Number,
        default: 0,
    },
});

const closeBtn = useTemplateRef('closeBtn');
const modalOpen = ref(false);

watch(modalOpen, async() =>
{
    await nextTick();
    closeBtn.value?.focus();
});
</script>

<style scoped>
@reference "#main.css";

.advanced-helper__label
{
    @apply cursor-pointer text-sm text-primary-500 underline transition
        hover:text-primary-700;
}

.advanced-helper__modal
{
    @apply w-auto min-w-[500px] max-w-[80vw] bg-white;
}

.advanced-helper__block
{
    @apply mb-4;
}

.advanced-helper__block:last-child
{
    @apply mb-0;
}
</style>
